import { fabric } from "fabric"

export function centerZoom(canvas, val) {
  let zoom = canvas.getZoom()
	let center = canvas.getCenter()
	zoom += val
	if (zoom > 15) zoom = 15
	if (zoom < 0.2) zoom = 0.2
	canvas.zoomToPoint({ x: center.left, y: center.top }, zoom);
}